import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    inject,
    Input,
    OnChanges,
    signal,
    SimpleChanges,
    WritableSignal,
} from '@angular/core';
import { SearchableDropdownInputModule } from '@ui/form/searchable-dropdown-input';
import { SearchableDropdownInputOption } from '@ui/form';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInput } from '@ui-v2/atoms/inputs/base-input';
import { ArrayUtils, DbUtils, SimpleChangesUtils } from '@core/utils';
import { RealEstateGroupService } from '@app/real-estate-group/services/real-estate-group.service';

@Component({
    selector: 'lib-real-estate-office-searchable-dropdown',
    standalone: true,
    imports: [SearchableDropdownInputModule, FormsModule],
    template: `
        <ui-searchable-dropdown-input
            [multiple]="false"
            [options]="options()"
            [hasMarginDouble]="false"
            [hasMargin]="false"
            (onChange)="onSelectionChange($event)"
            [(ngModel)]="innerModel"
            [debounceInput]="500"
        ></ui-searchable-dropdown-input>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RealEstateOfficeSearchableDropdownComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealEstateOfficeSearchableDropdownComponent extends BaseInput<string> implements OnChanges {
    @Input() public realEstateGroupId: string;

    public options: WritableSignal<SearchableDropdownInputOption[]> = signal([]);

    private readonly realEstateGroupService = inject(RealEstateGroupService);

    public writeValue(realEstateOfficeId: string) {
        this.innerModel = realEstateOfficeId;
    }

    public ngOnChanges({ realEstateGroupId }: SimpleChanges): void {
        if (SimpleChangesUtils.hasChanged(realEstateGroupId)) {
            this.options.set([]);
            this.propagateChange(null);
            if (!this.realEstateGroupId) return;
            this.realEstateGroupService
                .getOffices({
                    _id: this.realEstateGroupId,
                })
                .subscribe((result) => {
                    if (ArrayUtils.isEmpty(result)) this.options.set([]);
                    this.options.set(
                        result.map((realEstateAgentOffice) => ({
                            id: DbUtils.getStringId(realEstateAgentOffice),
                            label: realEstateAgentOffice.name,
                            value: DbUtils.getStringId(realEstateAgentOffice),
                        })),
                    );
                });
        }
    }

    public onSelectionChange($event: SearchableDropdownInputOption): void {
        this.propagateChange($event.id);
    }
}
